<div class="app-menu menuitem-active">
    <div class="logo-box ">
        <img [src]="logo" alt="small logo" class="logo-sm">
        <div class="sidebar-lg">
            <img [src]="logo" alt="dark logo" class="logo-lg" style="height: 50px;">
            <!-- <button class="button-toggle-menu text-light" (click)="toggleMenu()">
                <i class="pi pi-arrow-left"></i>
            </button> -->
        </div>
    </div>
    <div class="scrollbar show h-100" data-simplebar="init">
        <div class="simplebar-wrapper" style="margin: 0px;">
            <div class="simplebar-height-auto-observer-wrapper">
                <div class="simplebar-height-auto-observer"></div>
            </div>
            <div class="simplebar-mask">
                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                    <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content"
                        style="height: 100%; overflow: hidden scroll;">
                        <div class="simplebar-content" style="padding: 0px;">
                            <ul class="menu">
                                @for (m of menuItems; track m) {
                                <li class="menu-item" (click)="parentMenuClick(m)">
                                    <a [routerLink]="m?.link ? ['/'+m?.link]:null" [attr.tittle]="m?.title"
                                        [attr.aria-expanded]="showDropdown?.[m?.title]" style="cursor: pointer;"
                                        [class.collapsed]="!showDropdown?.[m?.title]" [queryParams]="m?.queryParams"
                                        data-bs-toggle="collapse" class="menu-link">
                                        <span class="menu-icon">
                                            <i [class]="m?.icon"></i>
                                        </span>
                                        <span class="menu-text">{{m?.title}}</span>
                                        @if(m?.children?.length){
                                        <span class="menu-arrow"></span>
                                        }
                                    </a>
                                    @if(m?.children?.length){
                                    <div class="collapse" [class.show]="showDropdown?.[m?.title]">
                                        <ul class="sub-menu">
                                            @for ( ch of m?.children ; track ch) {
                                            <li class="menu-item">
                                                <a href="javascript:void(0);" [routerLink]="['/'+ch?.link]"
                                                    [attr.tittle]="ch?.title" [queryParams]="ch?.queryParams"
                                                    class="menu-link">
                                                    <span class="menu-text">{{ch?.title}}</span>
                                                </a>
                                            </li>
                                            }
                                        </ul>
                                    </div>
                                    }
                                </li>
                                }
                            </ul>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="simplebar-placeholder" style="width: auto; height: 1527px;"></div>
        </div>
        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
        </div>
        <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
            <div class="simplebar-scrollbar"
                style="height: 25px; transform: translate3d(0px, 0px, 0px); display: block;"></div>
        </div>
    </div>
</div>